import "./index.scss";
import { forwardRef } from "react";
import { Button, Input } from "components/UI/atoms";
import { ReactComponent as SearchIcon } from "assets/search.svg";
import { ReactComponent as SearchButtonIcon } from "assets/search-button-icon.svg";
import { useWindowDimensions } from "hooks/useWindowDimensions";

export const SearchBrandsInputNavbar = forwardRef((props, ref) => {
  const {
    searchButtonLabel,
    placeholder,
    onInputChange,
    onInputFocus,
    onInputBlur,
    onFormSubmit
  } = props;

  const { width } = useWindowDimensions();
  const isMobileView = width <= 480;

  return (
    <form
      noValidate
      className="search-brands-form-navbar"
      onSubmit={onFormSubmit}
    >
      <SearchIcon className="search-icon" />
      <Input
        customClassName="search-input"
        aria-label="Search"
        autoComplete="off"
        id="search-homepage"
        name="search"
        type="text"
        placeholder={placeholder}
        onChange={onInputChange}
        onFocus={onInputFocus}
        onBlur={onInputBlur}
        ref={ref}
      />
      {searchButtonLabel && (
        <Button customClassName="search-button" type="submit">
          {isMobileView ? (
            <SearchButtonIcon
              className="search-icon-button"
              data-testid="search-icon-button"
            />
          ) : (
            searchButtonLabel
          )}
        </Button>
      )}
    </form>
  );
});
